// temporary backward compatibility
export * from "../constants/design";
export var States = {
  EXPANDED: 'expanded',
  RESTING: 'resting',
  SYMBOL: 'symbol'
};
export var HEADER_HOOKS = {
  BEFORE_LOGO: 'BEFORE_LOGO',
  AFTER_LOGO: 'AFTER_LOGO',
  BEFORE_NAVIGATION: 'BEFORE_NAVIGATION',
  AFTER_NAVIGATION: 'AFTER_NAVIGATION'
};